import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAnswersForUtteranceData } from "../../../../redux/actions/utterance";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles, CircularProgress } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import { generatePublicChatbotSnippet } from "../../../../redux/actions/connectionActions";

// Style
import styles from "./styles";

class MatchDialog extends Component {
  state = {
    isLoading: false,
    possibleAnswers: [],
    selectedAnswer: "",
    error: null
  };

  componentDidMount = () => {
    if (!this.props.publicChatbotProps) {
       this.props.generatePublicChatbotSnippet();
    }
  }

  removeDuplicatesFromArray = arr => [...new Set(arr.map(el => JSON.stringify(el)))].map(e => JSON.parse(e));

  handleClose = () => {
    this.props.parentCloseFunc();
  };

  handleSubmit = () => {
    if (!this.state.selectedAnswer) {
      this.setState({ error: "Please select a answer" });
      return;
    }
    this.props.parentCloseFunc(this.state.selectedAnswer);
  };

  handleAnswerSelect = e => {
    const newState = { ...this.state };
    newState.selectedAnswer = e.target.value;
    newState.error = null;
    this.setState(newState);
  };

  loadUtteranceAnswers = async () => {
    this.setState({ isLoading: true });
    await this.props.fetchAnswersForUtteranceData(this.props);
    this.setState({ isLoading: false, possibleAnswers: this.props.answers});
  } 

  loadSuggestions = async (e) => {
      if(e.target.value===""){
        this.loadUtteranceAnswers();
      }else{
      this.setState({ isLoading: true });
      let answers = await this.loadQuestionSuggestions(e.target.value);
      this.setState({ isLoading: false,
                      possibleAnswers: answers });
      }
  }

  parseFoundFaqsData = (hits) => {
    return hits.map(hit => {
      const source = hit._source;
      return {
        answer: source.question,
      }})
    }

  loadQuestionSuggestions = query => {
    const encodedQuery = encodeURIComponent(query);
    const encodedExtraFields = "";
    const chatbot = `${this.props.publicChatbotProps.data.GUID}_user_upload`;
    return axios
      .get(
        `https://api.responsum.ai/development/public-chat-bot/suggestions-v2/${chatbot}/${encodedQuery}?dontGroupResults=true&extraFields=${encodedExtraFields}`
      )
      .then(response => {
        // Custom fields are optional
         return this.parseFoundFaqsData(response.data.hits.hits); 
      })
      .catch(e => {
        console.error(e);
        return [];
      });
  };

  componentWillMount() {
    this.loadUtteranceAnswers();
  }

  generateAnswerDDL = answers => {
    return this.removeDuplicatesFromArray(answers);
  };

  render() {
    const { open, classes, cluster } = this.props;
    const { isLoading, possibleAnswers, error } = this.state;
    const text = cluster ? "Match and Save" : "Match";
    const answers = typeof possibleAnswers!=='undefined'?this.generateAnswerDDL(possibleAnswers):[];
    return (
      <div>
        <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">
            <Typography variant="h5">Select Best Answer</Typography>
          </DialogTitle>
          <DialogContent dividers>
              <React.Fragment>
                <DialogContentText>
                  Select an answer that best fits the selected utterance/s. If no answers matches to utterance just
                  close the dialog.
                </DialogContentText>
                <FormControl className={classes.formControl}>
                <Autocomplete
                  style={{ width: "100%" }}
                  getOptionSelected={(option, value) => option.answer === value.answer}
                  getOptionLabel={(option) => option.answer}
                  options={answers}
                  loading={isLoading}
                  onChange={(event, value) =>{
                    if(value){
                      	this.setState({selectedAnswer:value.answer})
                    }else{
                      this.setState({selectedAnswer:""})
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Start typing to search answers"
                      variant="outlined"
                      onChange={(e) => this.loadSuggestions(e)}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {isLoading ? <CircularProgress color="primary" size={22} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
                </FormControl>
                {error && (
                  <Typography className={classes.fieldError} variant="body2">
                    {error}
                  </Typography>
                )}
              </React.Fragment>
            {/* } */}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSubmit} color="primary">
              {text}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    answers: !_.isEmpty(state.utterance.answers) ? state.utterance.answers : [],
    chatbotId: state.utterance.chatbotId ? state.utterance.chatbotId : null,
    publicChatbotProps: state.connections.publicChatbotProps
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ fetchAnswersForUtteranceData, generatePublicChatbotSnippet }, dispatch),
    dispatch
  };
}
MatchDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(MatchDialog);

export default withStyles(styles)(MatchDialog);
